import type { IconSvgObject } from './types';

const ZapIcon: IconSvgObject = [
  ["path", { d: "M18 3L14 10H19L8 21L10 13H5L9.5 3H18Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default ZapIcon;
